import {useEffect, useState} from "react";
import associateServices from "../../../../services";
import GeneralStatsItem from "./item";
import '../index.css'
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
import GeneralStatsItemSkeleton from "../../general-debit-stats/web/skeleton-item";
import SlimSelect from 'slim-select'
import GeneralStatsItemRollerMobile from "./item-roller-mobile";

const GeneralStatsWebHighRollersMobile = props => {

    const {t} = useTranslation()
    const {loading, data,limit} = props

    return (
        <div className="tab-content">
            <div className="tab-pane fade show active">
                {
                    <div className="table-responsive mobile">
                        <table className="xtable mobile">
                            <thead>
                            {
                                loading ? <GeneralStatsItemSkeleton/> :
                                    <tr>
                                        {/*<th>#</th>*/}
                                        <th>{t(`stats.table.game`)}</th>
                                        <th>{t(`stats.table.profit`)}</th>
                                    </tr>
                            }

                            </thead>
                            <tbody>

                            {
                                loading ? Array.from({length: limit}).map((_, index) =>
                                        <GeneralStatsItemSkeleton key={index}/>) :
                                    data?.map((stat, i) => <GeneralStatsItemRollerMobile stat={stat}
                                                                             key={i}/>)
                            }

                            </tbody>
                        </table>
                    </div>
                }
            </div>

        </div>
    )

}

export default GeneralStatsWebHighRollersMobile
